<div class="quotation-wrapper">
  <flowaccount-quotation-document></flowaccount-quotation-document>

  <flowaccount-quotation-benefit></flowaccount-quotation-benefit>

  <flowaccount-quotation-form></flowaccount-quotation-form>

  <flowaccount-mobile-documents
    [heading]="'QUOTATION.MOBILE_DOCUMENTS.HEADING'"
    [contentDocuments]="contentDocuments"
  ></flowaccount-mobile-documents>

  <flowaccount-quotation-video></flowaccount-quotation-video>

  <flowaccount-content-call-to-action-squidex
    [contentCTA_1]="'CONTENT_CTA_SQUIDEX_QUOTATION.HEADING_1'"
    [contentCTA_2]="'CONTENT_CTA_SQUIDEX_QUOTATION.HEADING_2'"
    [contentTextLink]="'CONTENT_CTA_SQUIDEX_QUOTATION.BUTTON_LINK'"
    [contentScully]="'CONTENT_CTA_FUNCTION_QUOTATION'"
    [styleClass]="'function-quotation'"
    [previousPath]="signupPreviousPath.QUOTATION"
  >
  </flowaccount-content-call-to-action-squidex>

  <flowaccount-blog-swiper-squidex
    [lang]="translate.currentLang"
    [customHeader]="customHeader"
    [contentSquidex]="'quotation-blog'"
    [contentScully]="'quotation-blog-key'"
  ></flowaccount-blog-swiper-squidex>

  <flowaccount-review-setion [customTextList]="reviewSectionTextList"></flowaccount-review-setion>

  <ng-container *ngIf="translate.currentLang === 'th'">
    <flowaccount-faq-accordion-squidex
      [contentSquidex]="'quotation-faq'"
      [contentScully]="'quotation-faq-key'"
    ></flowaccount-faq-accordion-squidex>
  </ng-container>

  <flowaccount-content-call-to-action-privilege
    [contentCTA_1]="'CONTENT_CTA_PRIVILEGE_QUOTATION.HEADING_1'"
    [contentCTA_2]="'CONTENT_CTA_PRIVILEGE_QUOTATION.HEADING_2'"
    [contentCTA_mobile]="'CONTENT_CTA_PRIVILEGE_QUOTATION.HEADING_MOBILE'"
    [contentTextLink]="'CONTENT_CTA_PRIVILEGE_QUOTATION.BUTTON_LINK'"
  >
  </flowaccount-content-call-to-action-privilege>
</div>
